import * as React from "react";
import { CardWrap, CardWrapWithMobile } from "./styles";
export const CommentStarForWeb = (props) => {
    const { rateScore } = props;
    return (React.createElement(CardWrap, { key: "commentStar" }, [1, 2, 3, 4, 5].map((i, idx) => {
        if (rateScore >= i) {
            return React.createElement("i", { key: idx, "data-active": true });
        }
        if (rateScore < i && Math.ceil(rateScore) === i) {
            return (React.createElement("i", { key: idx },
                React.createElement("span", { style: {
                        width: `${(rateScore - i + 1) * 100}%`,
                    } })));
        }
        return React.createElement("i", { key: idx });
    })));
};
export const CommentStarForM = (props) => {
    const { rateScore } = props;
    return (React.createElement(CardWrapWithMobile, { key: "commentStar" }, [1, 2, 3, 4, 5].map((i, idx) => {
        if (rateScore >= i) {
            return React.createElement("i", { key: idx, "data-active": true });
        }
        if (rateScore < i && Math.ceil(rateScore) === i) {
            return (React.createElement("i", { key: idx },
                React.createElement("span", { style: {
                        width: `${(rateScore - i + 1) * 100}%`,
                    } })));
        }
        return React.createElement("i", { key: idx });
    })));
};
